webpackJsonp([4],{

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityMapTable_vue__ = __webpack_require__(2545);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a514ccc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityMapTable_vue__ = __webpack_require__(3304);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityMapTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a514ccc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityMapTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjxCustomerTable_vue__ = __webpack_require__(2634);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e67bbf50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjxCustomerTable_vue__ = __webpack_require__(3822);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjxCustomerTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e67bbf50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjxCustomerTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerDetail_vue__ = __webpack_require__(2635);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44a6421e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerDetail_vue__ = __webpack_require__(3823);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44a6421e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerBalanceFlowTable_vue__ = __webpack_require__(2636);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8e6543_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerBalanceFlowTable_vue__ = __webpack_require__(3824);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerBalanceFlowTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8e6543_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerBalanceFlowTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download


function download(data, strFileName, strMimeType, headers, finishCb) {

  var self = window,
      // this script is only for browsers anyway...
  defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
  mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    // if no filename and no mime, assume a url was passed as the only argument
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url; // assign href prop to temp anchor
    // if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.responseType = 'blob';
    for (var _i in headers) {
      if (headers.hasOwnProperty(_i)) {
        ajax.setRequestHeader(_i, headers[_i]);
      }
      // }
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime, headers, finishCb);
      };
      setTimeout(function () {
        ajax.send();
      }, 0); // allows setting custom ajax headers using the return:
      return ajax;
    } // end if valid url?
  } // end if url?


  //go ahead and download dataURLs right away
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {

    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
      navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
    }
  } else {
    //not data url, is it a string with special needs?
    if (/([\x80-\xff])/.test(payload)) {
      var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
      for (i; i < mx; ++i) {
        tempUiArr[i] = payload.charCodeAt(i);
      }payload = new myBlob([tempUiArr], { type: mimeType });
    }
  }
  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {

    if ('download' in anchor) {
      //html5 A[download]
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
        if (finishCb) {
          finishCb();
        }
      }, 66);
      return true;
    }

    // handle non-a[download] safari as best we can:
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        // popup blocked, offer direct download:
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode && /^data:/.test(url)) {
      // force a mime that will download:
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  } //end saver


  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    // Blob but not URL support:
    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

/* harmony default export */ __webpack_exports__["a"] = (download);

/***/ }),

/***/ 1822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    onUploadFile: function onUploadFile(file, type) {
      var _this = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 9); // 客户管理
      formData.append('type', type); // 批量类型
      formData.append('file_type', 1); // 文件类型:上传excel

      request.common('batchCreateCustomerReceiptInfo', formData).then(function (_ref) {
        var data = _ref.data;

        _this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this.$options.name === 'CustomerBatchTable' ? _this.onRefresh() : _this.$router.push('/customer/batch-table');
      });
    },
    downCustomerInvoiceUploadTpl: function downCustomerInvoiceUploadTpl() {
      var demo = [{
        'customer_id': '客户名称/客户编号',
        'company': '开票信息',
        'bank_info': '开票信息',
        'address': '开票信息',
        'customer_num': '开票信息'
      }];
      var fileHeader = [{ key: 'customer_id', text: '客户编号' }, { key: 'company', text: '公司名称' }, { key: 'bank_info', text: '开户行及账号' }, { key: 'address', text: '地址及电话' }, { key: 'customer_num', text: '纳税人识别号' }];
      this.$export('批量更新开票信息模板', demo, { fileHeader: fileHeader });
    },
    closeCustomerInvoiceUploadDialog: function closeCustomerInvoiceUploadDialog() {
      this.uploadDialogVisible = false;
    },
    showCustomerInvoiceUploadDialog: function showCustomerInvoiceUploadDialog() {
      this.uploadDialogVisible = true;
    }
  }
});

/***/ }),

/***/ 1927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendor_download__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(77);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [],
  components: {},
  data: function data() {
    return {
      visible: false,
      fileList: [],
      customerid: null,
      name: null,
      number: null,
      form: [],
      load: false,
      expImgUrl: '/static/img/customer-receipt.png'
    };
  },

  methods: {
    openDialog: function openDialog(customer) {
      var _this = this;

      // 清空并设置所需字段
      this.customerid = customer.customerid;
      this.name = customer.name;
      this.number = customer.number;
      var id = this.customerid;
      this.form = [];

      // 获取该客户下所有发票信息
      request.page('getCustomerReceiptInfo', { customerid: id }).then(function (_ref) {
        var data = _ref.data;

        _this.visible = true;
        for (var i = 0; i < data.length; i++) {
          _this.form.push(data[i]);
          _this.form[i].attached_file = _this.form[i].attached_file.filter(function (item) {
            return item;
          });
        }
      });
    },
    onGetPdfFile: function onGetPdfFile(item) {
      var _this2 = this;

      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__vendor_download__["a" /* default */])(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["c" /* getToken */])()
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '下载已取消'
        });
      });
    },
    onViewImage: function onViewImage(event) {
      if (event.target.src) {
        this.views = new __WEBPACK_IMPORTED_MODULE_1_viewerjs___default.a(event.target, {
          url: function url(image) {
            return event.target.src;
          }
        });
      }
      this.views.view();
    }
  }
});

/***/ }),

/***/ 1928:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customer_mixins__ = __webpack_require__(1822);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__customer_mixins__["a" /* default */]],
  data: function data() {
    return {
      uploadFileList: []
    };
  },

  props: {
    visible: Boolean
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    },
    onCancelUpload: function onCancelUpload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.closeDialog();
    },
    onSubmitUpload: function onSubmitUpload(type) {
      if (this.uploadFileList.length < 1) {
        this.$message.error('请选择合适的 excel 文件!');
        return false;
      }
      this.onUploadFile(this.uploadFileList[0], type);
    },
    onChangeUploadFile: function onChangeUploadFile(file, fileList) {
      var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

      var isLimit = file.raw.size / 1024 / 1024 < size;
      if (!isLimit) {
        this.$message.error('\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7' + size + 'MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      this.uploadFileList = fileList;
      fileList.splice(0, fileList.length - 1);
    },
    onRemoveUploadFile: function onRemoveUploadFile(file, fileList) {
      this.uploadFileList = fileList;
    }
  }
});

/***/ }),

/***/ 2111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerBatchInvoiceUploadDialog_vue__ = __webpack_require__(1928);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f9db46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerBatchInvoiceUploadDialog_vue__ = __webpack_require__(2160);
function injectStyle (ssrContext) {
  __webpack_require__(2158)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21f9db46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerBatchInvoiceUploadDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f9db46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerBatchInvoiceUploadDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2155:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2156);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2ab0ba72", content, true, {});

/***/ }),

/***/ 2156:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".receipt-detail[data-v-0a446ce8]{font-size:20px;margin-left:50px}.medium[data-v-0a446ce8]{width:700px}.form-item[data-v-0a446ce8]{width:580px}.el-dialog-div[data-v-0a446ce8]{overflow:auto}.receipt-button[data-v-0a446ce8]{margin:0 0 10px}.view-navbar[data-v-0a446ce8]{right:0;bottom:0;width:100%;overflow:hidden;display:inline;float:left}ul[data-v-0a446ce8]{-webkit-transform:translateX(0);transform:translateX(0);-webkit-transition:all .3s;transition:all .3s;-webkit-box-sizing:content-box;box-sizing:content-box;overflow:hidden;padding:1px 0}li[data-v-0a446ce8]{float:left;list-style:none;width:100px;height:100px;margin-right:5px;cursor:pointer;font-size:0;line-height:0;overflow:hidden;-webkit-transition:opacity .15s;transition:opacity .15s}.flex-jc-end[data-v-0a446ce8]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.flex-ai-start[data-v-0a446ce8],.flex-jc-end[data-v-0a446ce8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.flex-ai-start[data-v-0a446ce8]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}", "", {"version":3,"sources":["/workspace/src/views/customer/components/CustomerReceiptForm.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,gBAAkB,CACnB,AACD,yBACE,WAAa,CACd,AACD,4BACE,WAAa,CACd,AACD,gCACE,aAAe,CAChB,AACD,iCACE,eAAmB,CACpB,AACD,8BACE,QAAW,AACX,SAAY,AACZ,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,oBACE,gCAAmC,AAC3B,wBAA2B,AACnC,2BAA6B,AAC7B,mBAAqB,AACrB,+BAAgC,AACxB,uBAAwB,AAChC,gBAAiB,AACjB,aAAe,CAChB,AACD,oBACE,WAAY,AACZ,gBAAiB,AACjB,YAAa,AACb,aAAc,AACd,iBAAkB,AAClB,eAAgB,AAChB,YAAa,AACb,cAAe,AACf,gBAAiB,AACjB,gCAAkC,AAClC,uBAA0B,CAC3B,AACD,8BAQE,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,8DAXE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAgB7B,AAXD,gCAQE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"CustomerReceiptForm.vue","sourcesContent":["\n.receipt-detail[data-v-0a446ce8] {\n  font-size: 20px;\n  margin-left: 50px;\n}\n.medium[data-v-0a446ce8] {\n  width: 700px;\n}\n.form-item[data-v-0a446ce8] {\n  width: 580px;\n}\n.el-dialog-div[data-v-0a446ce8] {\n  overflow: auto;\n}\n.receipt-button[data-v-0a446ce8] {\n  margin: 0 0 10px 0;\n}\n.view-navbar[data-v-0a446ce8] {\n  right: 0px;\n  bottom: 0px;\n  width: 100%;\n  overflow: hidden;\n  display: inline;\n  float: left;\n}\nul[data-v-0a446ce8] {\n  -webkit-transform: translateX(0px);\n          transform: translateX(0px);\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  overflow: hidden;\n  padding: 1px 0;\n}\nli[data-v-0a446ce8] {\n  float: left;\n  list-style: none;\n  width: 100px;\n  height: 100px;\n  margin-right: 5px;\n  cursor: pointer;\n  font-size: 0;\n  line-height: 0;\n  overflow: hidden;\n  -webkit-transition: opacity 0.15s;\n  transition: opacity 0.15s;\n}\n.flex-jc-end[data-v-0a446ce8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.flex-ai-start[data-v-0a446ce8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-dialog',{attrs:{"visible":_vm.visible,"title":"客户开票信息","width":"60%","max-height":"300px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"el-dialog-div"},[_c('el-row',{staticStyle:{"margin-bottom":"30px"}},[_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("客户名称："+_vm._s(_vm.name))])]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("客户编号："+_vm._s(_vm.number))])])],1),_vm._v(" "),_vm._l((_vm.form),function(detailItem,itemIndex){return _c('el-form',{key:itemIndex,ref:"form",refInFor:true,attrs:{"model":detailItem,"size":"medium","label-width":"120px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium",staticStyle:{"position":"relative"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"公司名称","prop":"company_name"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":detailItem.company_name,"placement":"top"}},[_c('span',[_vm._v(_vm._s(detailItem.company_name))])])],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"开户行及账号","prop":"bank_info"}},[_c('span',[_vm._v(_vm._s(detailItem.bank_info))])]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"地址及电话","prop":"address_phone"}},[_c('span',[_vm._v(_vm._s(detailItem.address_phone))])]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"税号","prop":"tax_number"}},[_c('span',[_vm._v(_vm._s(detailItem.tax_number))])]),_vm._v(" "),(detailItem.attached_file.length)?_c('el-form-item',{attrs:{"label":""}},[[_c('div',{staticClass:"view-navbar"},[_c('ul',{staticClass:"clear-both"},_vm._l((detailItem.attached_file),function(item,index){return _c('li',{key:index},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":item.name,"placement":"bottom"}},[(item.type === 'pic')?_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":item.tmp_url},on:{"click":_vm.onViewImage}}):_vm._e(),_vm._v(" "),(item.type === 'pdf' || item.type === 'eml')?_c('i',{staticClass:"sj-icon-pdf",staticStyle:{"font-size":"100px","margin-top":"50px"},on:{"click":function($event){return _vm.onGetPdfFile(item, index)}}}):_vm._e()])],1)}),0)])]],2):_vm._e(),_vm._v(" "),(itemIndex < _vm.form.length - 1)?_c('hr',{staticStyle:{"border":"1px dashed","color":"#999","margin-bottom":"20px"}}):_vm._e()],1)])])}),_vm._v(" "),_c('div',[_c('hr',{staticStyle:{"border":"1px dashed","color":"#999","margin-bottom":"20px"}}),_vm._v(" "),_c('p',[_vm._v("注：如需新增或修改开票信息，请发邮件给财务开票的同事。")]),_vm._v(" "),_c('p',[_vm._v("邮件内容请注明：")]),_vm._v(" "),_c('p',[_vm._v("1、新增开票信息或修改开票信息；")]),_vm._v(" "),_c('p',[_vm._v("2、客户名称，客户ID；（如：“客户名称：零启营销，客户ID：353”）；")]),_vm._v(" "),_c('p',[_vm._v("3、客户最新的开票信息：公司名称、开户行及账号、地址及电话、税号；")]),_vm._v(" "),_c('p',[_vm._v("4、客户提供的开票信息的证明文件。")]),_vm._v(" "),_c('div',{staticClass:"flex-ai-start"},[_c('span',{staticStyle:{"margin-right":"6px"}},[_vm._v("示例")]),_vm._v(" "),_c('el-image',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.expImgUrl,"preview-src-list":[_vm.expImgUrl]}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex-jc-end"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.visible = false}}},[_vm._v("关闭\n        ")])],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2158:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2159);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("59822434", content, true, {});

/***/ }),

/***/ 2159:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CustomerBatchInvoiceUploadDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{staticClass:"customer-batch-invoice-upload-dialog",attrs:{"title":"批量更新开票信息","visible":_vm.visible,"before-close":_vm.closeDialog},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('el-row',{staticClass:"batch-invoice-upload-row"},[_c('el-upload',{ref:"upload",staticClass:"upload-batch-invoice",attrs:{"action":"","file-list":_vm.uploadFileList,"on-change":function (file, fileList) {_vm.onChangeUploadFile(file, fileList, 10)},"on-remove":_vm.onRemoveUploadFile,"accept":".xlsx,.xls","auto-upload":false}},[_c('el-button',{attrs:{"icon":"","type":"primary","size":"medium"}},[_vm._v("上传文件\n        ")])],1),_vm._v(" "),_c('el-button',{attrs:{"size":"medium","type":"text"},on:{"click":_vm.downCustomerInvoiceUploadTpl}},[_vm._v("下载模板\n      ")])],1),_vm._v(" "),_c('el-row',[_c('button-gutter',{staticStyle:{"float":"right"}},[_c('el-button',{attrs:{"size":"medium"},on:{"click":_vm.onCancelUpload}},[_vm._v("取消\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.onSubmitUpload(235)}}},[_vm._v("确定\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_city_map_components_CityMap__ = __webpack_require__(3299);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CityMap: __WEBPACK_IMPORTED_MODULE_1__views_city_map_components_CityMap__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__views_city_map_components_CityMap__["a" /* default */]],
  data: function data() {
    return {
      provinceParams: { type: 0, parentid: -1 },
      cityParams: {},
      areaParams: {}
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    setParams: function setParams(params) {
      switch (params.type) {
        case 0:
          this.provinceParams = params;
          break;
        case 1:
          this.cityParams = params;
          this.areaParams = {};
          break;
        case 2:
          this.areaParams = params;
          break;
      }
    },
    onUploadFile: function onUploadFile(file, type) {
      var _this = this;

      var isLt10M = file.raw.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!');
        this.$refs.upload.clearFiles();
        return false;
      }

      var formData = new FormData();
      formData.append('file', file.raw);
      formData.append('collection_type', 3); // 卖场管理
      formData.append('type', type); // 批量任务类型
      formData.append('file_type', 1); // 文件类型:上传excel

      request.common('createTaskBatch', formData).then(function (_ref) {
        var data = _ref.data;

        _this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        _this.onSearch();
      });
    },
    exportCityMaps: function exportCityMaps() {
      var _this2 = this;

      request.common('batchExportCityMaps').then(function (res) {
        _this2.$confirm('任务创建成功, 是否前往批量任务列表查看?', '任务创建成功', {
          confirmButtonText: '前往任务列表',
          cancelButtonText: '关闭弹层',
          type: 'warning'
        }).then(function () {
          _this2.$router.push('/market/upload/table');
        }).catch(function () {});
      }).catch(function () {});
    }
  })
});

/***/ }),

/***/ 2546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__city_map_rules_js__ = __webpack_require__(3302);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CityMap',
  props: {
    labelName: String,
    params: Object
  },
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_7__city_map_rules_js__["a" /* formRules */],
      table: [],
      emptyText: '',
      currentVisible: false,
      salaryVisible: false,
      form: {
        id: null,
        name: null,
        region_code: null,
        level: null,
        city_order_coefficient: null
      },
      city_salary: [{
        task_salary: null,
        task_type: null
      }]
    };
  },
  created: function created() {
    this.getTableData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.cityMap.options;
    },
    taskOptions: function taskOptions(state) {
      return state.order.options;
    }
  })),
  watch: {
    params: {
      handler: function handler(val) {
        this.getTableData();
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    // 省市区列表展示
    getTableData: function getTableData() {
      var _this = this;

      if (!this.params || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.params) === '{}') {
        this.emptyText = '请选择上级目标';
        this.table = [];
      } else {
        var params = filter.copyJson(this.params);
        request.common('getCitymapTable', params).then(function (res) {
          _this.table = res.data;

          if (_this.table.length === 0) {
            _this.emptyText = '没有查询到相关信息';
          }
        }).catch(function () {
          _this.table = [];
        });
      }
    },

    // 点击父级后展示子级列表
    setNextData: function setNextData(row) {
      if (row.type < 2) {
        var params = { type: row.type + 1, parentid: row.id };
        this.$emit('getParams', params);
      }
    },

    // 添加省市区，市区需点击上一级
    onAdd: function onAdd() {
      if (!this.params || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.params) === '{}') {
        this.$message.error('未选择上一级');
        return;
      }
      this.form = {
        name: null,
        region_code: null,
        level: null
      };
      this.currentVisible = true;
    },

    // 编辑
    onEdit: function onEdit(id) {
      var _this2 = this;

      request.alert('getCitymapDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        if (data.region_code === '0') {
          delete data.region_code;
        }
        _this2.form = data;
        _this2.currentVisible = true;
      }).catch(function (res) {});
    },
    onDelete: function onDelete(id) {
      var _this3 = this;

      this.$confirm('你确定要删除吗？', '提示', { type: 'warning' }).then(function () {
        request.alert('deleteCitymap', { id: id }).then(function (_ref2) {
          var data = _ref2.data;

          _this3.$message.success('删除成功！');

          _this3.$emit('getParams', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this3.params, { refresh: 1 }));
        }).catch(function (res) {});
      }).catch(function () {
        _this3.$message.info('已取消删除');
      });
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      if (this.form.id) {
        request.alert('updateCitymap', this.form).then(function (_ref3) {
          var data = _ref3.data;

          _this4.currentVisible = false;
          _this4.$message.success('提交成功！');
        }).catch(function (res) {});
      } else {
        this.form.type = this.params.type;
        this.form.parentid = this.params.parentid;
        request.alert('createCitymap', this.form).then(function (_ref4) {
          var data = _ref4.data;

          _this4.currentVisible = false;
          _this4.$message.success('提交成功！');
          _this4.$emit('getParams', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this4.params, { refresh: 1 }));
        }).catch(function (res) {});
      }
    },

    // 编辑城市单价
    onEditSalary: function onEditSalary(id) {
      var _this5 = this;

      this.city_salary = [{
        task_salary: null,
        task_type: null
      }];
      request.alert('getCitymapDetail', { id: id }).then(function (_ref5) {
        var data = _ref5.data;

        if (data.region_code === '0') {
          delete data.region_code;
        }
        _this5.form = data;
        _this5.salaryVisible = true;
        request.alert('getCitySalary', { id: id }).then(function (_ref6) {
          var data = _ref6.data;

          if (data.length) {
            _this5.city_salary = data;
          }
        }).catch(function (res) {});
      }).catch(function (res) {});
    },

    // 提交城市单价
    onSubmitSalary: function onSubmitSalary() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, form;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this6.$refs.salaryForm) {
                  _this6.$message.error('提交内容填写不正确！');
                }
                promises = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this6.$refs.salaryForm); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  form = _step.value;

                  promises.push(form.validate());
                }
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 13:
                _context.prev = 13;
                _context.prev = 14;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 16:
                _context.prev = 16;

                if (!_didIteratorError) {
                  _context.next = 19;
                  break;
                }

                throw _iteratorError;

              case 19:
                return _context.finish(16);

              case 20:
                return _context.finish(13);

              case 21:
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                  var id = _this6.form.id;
                  request.common('updateCitySalary', { id: id, city_salary: _this6.city_salary }).then(function (res) {
                    _this6.$message({
                      showClose: true,
                      message: '保存成功',
                      type: 'success'
                    });
                    _this6.salaryVisible = false;
                  });
                }).catch(function () {
                  _this6.$message.error('提交内容填写不正确！');
                });

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6, [[5, 9, 13, 21], [14,, 16, 20]]);
      }))();
    },

    // 添加一条城市单价
    onAddDetail: function onAddDetail() {
      var params = {
        task_salary: null,
        task_type: null
      };
      this.city_salary.push(params);
    },

    // 删除一条城市单价
    onDelItem: function onDelItem(index) {
      this.city_salary.splice(index, 1);
    }
  })
});

/***/ }),

/***/ 2633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_customer_components_CustomerReceiptForm__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_mixins__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_customer_components_CustomerBatchInvoiceUploadDialog__ = __webpack_require__(2111);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__customer_mixins__["a" /* default */]],
  components: { CustomerReceiptForm: __WEBPACK_IMPORTED_MODULE_2__views_customer_components_CustomerReceiptForm__["default"], CustomerBatchInvoiceUploadDialog: __WEBPACK_IMPORTED_MODULE_5__views_customer_components_CustomerBatchInvoiceUploadDialog__["a" /* default */] },
  data: function data() {
    return {
      search: {
        show_filter: '',
        keyword: '',
        type: this.$route.params.type || null
      },
      optionModel: {
        customerType: []
      },
      uploadDialogVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.customer.options;
    }
  })),

  created: function created() {
    var _this = this;

    request.page('getCustomerTaskOptions').then(function (_ref) {
      var data = _ref.data;

      _this.optionModel.customerType = _this.optionModel.customerType.concat(data.customerType);
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      params = filter.copyJson(params);
      return request.page('getCustomerTable', params).then(function (data) {
        if (data.data && data.data.data && data.data.data.length > 0) {
          data.data.data = data.data.data.map(function (one) {
            one.contact_persons = JSON.parse(one.contact_persons);
            return one;
          });
        }
        return data;
      });
    },
    formatDate: function formatDate(value) {
      return filter.formatUnix(value);
    },
    jumpToCustomerProjectTale: function jumpToCustomerProjectTale(customer) {
      this.$store.commit('SELECTED_CUSTOMER', customer);
      this.$router.push('/project/table/' + customer.id);
    },
    jumpToCustomerForm: function jumpToCustomerForm(id) {},
    onDelete: function onDelete(id) {
      var _this2 = this;

      this.$confirm('确定要删除吗？', '警告', { type: 'warning' }).then(function (_) {
        request.common('deleteCustomerData', { id: id }).then(function (_) {
          _this2.$message.success('删除成功');
          _this2.onSearch();
        });
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    openDialog: function openDialog(row) {
      var customer = {};
      customer.customerid = row.id;
      customer.number = row.number;
      customer.name = row.name;
      this.$refs.receiptDialog.openDialog(customer);
    },
    getContactPerson: function getContactPerson(row, field) {
      if (row.contact_persons && row.contact_persons.length > 0) {
        return row.contact_persons[0][field];
      }
      return '';
    }
  })
});

/***/ }),

/***/ 2634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_customer_components_CustomerReceiptForm__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customer_mixins__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_customer_components_CustomerBatchInvoiceUploadDialog__ = __webpack_require__(2111);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__customer_mixins__["a" /* default */]],
  components: { CustomerReceiptForm: __WEBPACK_IMPORTED_MODULE_2__views_customer_components_CustomerReceiptForm__["default"], CustomerBatchInvoiceUploadDialog: __WEBPACK_IMPORTED_MODULE_5__views_customer_components_CustomerBatchInvoiceUploadDialog__["a" /* default */] },
  data: function data() {
    return {
      search: {
        show_filter: '',
        keyword: '',
        type: 70
      },
      optionModel: {
        customerType: []
      },
      uploadDialogVisible: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.customer.options;
    }
  })),

  created: function created() {
    var _this = this;

    request.page('getCustomerTaskOptions').then(function (_ref) {
      var data = _ref.data;

      _this.optionModel.customerType = _this.optionModel.customerType.concat(data.customerType);
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      params = filter.copyJson(params);
      return request.page('getCustomerTable', params);
    },
    formatDate: function formatDate(value) {
      return filter.formatUnix(value);
    },
    jumpToCustomerProjectTale: function jumpToCustomerProjectTale(customer) {
      this.$router.push('/project/ajx/table/' + customer.id);
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    openDialog: function openDialog(row) {
      var customer = {};
      customer.customerid = row.id;
      customer.number = row.number;
      customer.name = row.name;
      this.$refs.receiptDialog.openDialog(customer);
    }
  })
});

/***/ }),

/***/ 2635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      table: [{
        key: 'id',
        label: '客户ID',
        value: ''
      }, {
        key: 'number',
        label: '客户唯一编号',
        value: ''
      }, {
        key: 'name',
        label: '客户名称',
        value: ''
      }, {
        key: 'company',
        label: '客户公司',
        value: ''
      }, {
        key: 'managementfees',
        label: '客户管理费率',
        value: ''
      }, {
        key: 'balance',
        label: '客户当前余额',
        value: ''
      }, {
        key: 'pendingfee',
        label: '客户当前冻结金额',
        value: ''
      }, {
        key: 'totalspentmoney',
        label: '客户总消费金额',
        value: ''
      }, {
        key: 'totaltasknum',
        label: '客户总投放任务',
        value: ''
      }, {
        key: 'totalhirenum',
        label: '客户总雇佣人数',
        value: ''
      }, {
        key: 'ongoingtasknum',
        label: '客户当前进行中的任务',
        value: ''
      }]
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.id = this.$route.params.id;
    this.id > 0 && this.setDetailData(this.id);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getCustomerBalanceDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        _this.table.forEach(function (obj) {
          if (data[obj.key]) {
            obj.value = data[obj.key];

            if (obj.key === 'managementfees') {
              obj.value = parseFloat(obj.value) * 100 + '%';
            }

            if (obj.key === 'ongoingtasknum') {
              obj.value += ' (\u5956\u91D1\u603B\u989D: ' + data.ongoingtaskmoney + ')';
            }

            if (obj.key === 'totalspentmoney') {
              obj.value += ' (\u7BA1\u7406\u8D39: ' + data.totalmanagementfee + ')';
            }
          }
        });

        _this.$store.commit('SELECTED_CUSTOMER_DETAIL', data);
      });
    }
  })
});

/***/ }),

/***/ 2636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_1__core_mixins_dateTimePicker__["a" /* default */]],
  data: function data() {
    return {
      customerName: null,
      customerBalance: null,
      id: this.$route.params.id,
      search: {
        id: this.$route.params.id
      },
      exportHeader: [{
        key: 'id',
        text: '客户ID'
      }, {
        key: 'projectid',
        text: '项目ID'
      }, {
        key: 'amount',
        text: '消费金额'
      }, {
        key: 'updatetime',
        text: '消费时间'
      }, {
        key: 'taskid',
        text: '相关任务'
      }, {
        key: 'managementfee',
        text: '管理费用'
      }, {
        key: 'desc',
        text: '备注'
      }]
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      this.setCustomer();
      params.id = this.$route.params.id;
      return request.page('getCustomerBalanceFlowTable', params);
    },
    setCustomer: function setCustomer() {
      var _this = this;

      request.common('getCustomerBalanceDetail', { id: this.$route.params.id }).then(function (_ref) {
        var data = _ref.data;

        _this.customerName = data.name;
        _this.customerBalance = data.balance;
      });
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: function getResponseData(data) {
          if (data.total > 0) {
            for (var i in data.data) {
              if (data.data.hasOwnProperty(i)) {
                data.data[i].managementfee += '(\u7BA1\u7406\u8D39\u7387: ' + data.data[i].managementrate * 100 + '%)';
              }
            }
          }

          return data;
        }
      });
    }
  })
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerTable_vue__ = __webpack_require__(2633);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbd56442_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerTable_vue__ = __webpack_require__(3821);
function injectStyle (ssrContext) {
  __webpack_require__(3819)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbd56442"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbd56442_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityMap_vue__ = __webpack_require__(2546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e10428_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityMap_vue__ = __webpack_require__(3303);
function injectStyle (ssrContext) {
  __webpack_require__(3300)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e10428"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e10428_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3300:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3301);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1e689d0b", content, true, {});

/***/ }),

/***/ 3301:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".salary-button[data-v-56e10428]{float:right}.form-item[data-v-56e10428]{width:300px}.el-dialog-div[data-v-56e10428]{height:50vh;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/city-map/components/CityMap.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd,AACD,4BACE,WAAa,CACd,AACD,gCACE,YAAa,AACb,aAAe,CAChB","file":"CityMap.vue","sourcesContent":["\n.salary-button[data-v-56e10428] {\n  float: right;\n}\n.form-item[data-v-56e10428] {\n  width: 300px;\n}\n.el-dialog-div[data-v-56e10428] {\n  height: 50vh;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule__ = __webpack_require__(1345);



var searchRules = {};

var formRules = {
  task_type: [{ required: true, message: '任务类型不能为空', trigger: 'blur' }],
  task_salary: [{ required: true, message: '城市单价不能为空', trigger: 'blur' }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule__["a" /* makeRule */])('请输入小于1000的数字', 'number', ['change', 'blur']), { min: 0, max: 1000 })]
};

/***/ }),

/***/ 3303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"0"}},[_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"primary","size":"mini","icon":"el-icon-plus"},on:{"click":_vm.onAdd}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"26%","float":"left","margin-left":"20px","margin-top":"50px"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":"","empty-text":_vm.emptyText},on:{"row-click":_vm.setNextData}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.labelName,"min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"查看/修改城市单价","placement":"top","enterable":false}},[(_vm.params.type === 1)?_c('el-button',{attrs:{"icon":"sj-icon-city-salary","size":"mini","type":"primary","circle":""},on:{"click":function($event){return _vm.onEditSalary(scope.row.id)}}}):_vm._e()],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-edit","size":"mini","circle":""},on:{"click":function($event){return _vm.onEdit(scope.row.id)}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-delete","size":"mini","circle":""},on:{"click":function($event){return _vm.onDelete(scope.row.id)}}})]}}])})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增/编辑市区信息","visible":_vm.currentVisible,"width":"40%"},on:{"update:visible":function($event){_vm.currentVisible=$event}}},[_c('el-form',{ref:"form",staticClass:"demo-ruleForm",attrs:{"model":_vm.form,"label-width":"120px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('el-row',{staticClass:"text item"},[_c('el-form-item',{attrs:{"prop":"name","label":"名称:"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),(_vm.params.type === 1)?_c('el-form-item',{attrs:{"prop":"level","label":"城市等级:"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择"},model:{value:(_vm.form.level),callback:function ($$v) {_vm.$set(_vm.form, "level", $$v)},expression:"form.level"}},_vm._l((_vm.options.levels),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"code","label":"行政区代码:"}},[_c('el-input',{model:{value:(_vm.form.region_code),callback:function ($$v) {_vm.$set(_vm.form, "region_code", $$v)},expression:"form.region_code"}})],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.currentVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("确 定")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"新增/编辑城市单价","visible":_vm.salaryVisible,"width":"40%"},on:{"update:visible":function($event){_vm.salaryVisible=$event}}},[_c('div',{staticClass:"el-dialog-div"},[_c('el-row',{staticStyle:{"margin-bottom":"30px"}},[_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("城市名称: "+_vm._s(_vm.form.name))])]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("城市等级: "+_vm._s(_vm.form.level))])]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("行政区代码: "+_vm._s(_vm.form.region_code))])]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('span',{staticClass:"receipt-detail"},[_vm._v("城市接单系数: "+_vm._s(_vm.form.city_order_coefficient))])])],1),_vm._v(" "),_vm._l((_vm.city_salary),function(detailItem,itemIndex){return _c('el-form',{key:itemIndex,ref:"salaryForm",refInFor:true,attrs:{"rules":_vm.formRules,"model":detailItem,"size":"medium","label-width":"120px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-button',{staticClass:"salary-button",attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onDelItem(itemIndex)}}},[_vm._v("删除\n              ")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"任务类型","prop":"task_type"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(detailItem.task_type),callback:function ($$v) {_vm.$set(detailItem, "task_type", $$v)},expression:"detailItem.task_type"}},_vm._l((_vm.taskOptions.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])])}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"城市单价","prop":"task_salary"}},[_c('el-input',{model:{value:(detailItem.task_salary),callback:function ($$v) {_vm.$set(detailItem, "task_salary", $$v)},expression:"detailItem.task_salary"}})],1),_vm._v(" "),(itemIndex < _vm.city_salary.length - 1)?_c('hr',{staticStyle:{"border":"1px dashed","color":"#999","margin-bottom":"50px"}}):_vm._e()],1)])])})],2),_vm._v(" "),_c('div',[_c('el-button',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.onAddDetail()}}},[_vm._v("添加\n        ")])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.salaryVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmitSalary()}}},[_vm._v("确 定")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('div',[_c('layout-panel',[_c('el-upload',{ref:"upload",staticClass:"upload-demo",staticStyle:{"width":"130px","margin-bottom":"10px","display":"inline-block"},attrs:{"action":"","auto-upload":false,"on-change":function (query) { return _vm.onUploadFile(query, 246); },"accept":".xlsx,.xls","show-file-list":false}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("批量更新城市单价\n        ")])],1),_vm._v(" "),_c('el-button',{attrs:{"icon":"sj-icon-export","type":"primary","size":"small"},on:{"click":function($event){return _vm.exportCityMaps()}}},[_vm._v("导出省市区关系\n      ")]),_vm._v(" "),_c('city-map',{attrs:{"params":_vm.provinceParams,"labelName":"省份"},on:{"getParams":_vm.setParams}}),_vm._v(" "),_c('city-map',{attrs:{"params":_vm.cityParams,"labelName":"市区"},on:{"getParams":_vm.setParams}}),_vm._v(" "),_c('city-map',{attrs:{"params":_vm.areaParams,"labelName":"地区"},on:{"getParams":_vm.setParams}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3819:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3820);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3c7410f4", content, true, {});

/***/ }),

/***/ 3820:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".link[data-v-dbd56442]{color:#409eff;padding:5px 10px;cursor:pointer}", "", {"version":3,"sources":["/workspace/src/views/customer/pages/CustomerTable.vue"],"names":[],"mappings":"AACA,uBAAuB,cAAc,iBAAiB,cAAc,CACnE","file":"CustomerTable.vue","sourcesContent":["\n.link[data-v-dbd56442]{color:#409EFF;padding:5px 10px;cursor:pointer\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入客户名称","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否显示","prop":"show_filter"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择是否显示","clearable":""},model:{value:(_vm.search.show_filter),callback:function ($$v) {_vm.$set(_vm.search, "show_filter", $$v)},expression:"search.show_filter"}},_vm._l(([{label: '显示', value: '1'}, {label: '不显示', value: '0'}]),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n          ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('router-link',{attrs:{"to":'/customer-task/create'}},[_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"}},[_vm._v("添加\n          ")])],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"number","label":"客户编号","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"客户名称","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"link",on:{"click":function($event){return _vm.jumpToCustomerProjectTale(scope.row)}}},[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"show_in_statistics","label":"是否显示","min-width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.showInStatistics),function(item){return (scope.row.show_in_statistics === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"company","label":"所属公司","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"客户类型","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.optionModel.customerType),function(item){return (scope.row.type === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"managementfees","label":"管理费比例","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm._f("toFixed")(scope.row.managementfees * 100,1))+"%")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"客户联系人","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.getContactPerson(scope.row, 'name')))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":"联系方式","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.getContactPerson(scope.row, 'phone')))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":"邮箱","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(_vm.getContactPerson(scope.row, 'email')))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"detail","label":"描述","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createtime","label":"创建时间","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.formatDate(scope.row.createtime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatetime","label":"最后更新时间","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.formatDate(scope.row.updatetime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('button-gutter',[_c('router-link',{attrs:{"to":("/customer/detail/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("客户详情")])],1),_vm._v(" "),_c('el-button',{attrs:{"icon":"","type":"primary","size":"mini"},on:{"click":function($event){return _vm.openDialog(scope.row)}}},[_vm._v("开票信息\n              ")]),_vm._v(" "),_c('router-link',{attrs:{"to":("/customer-task/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("修改")])],1),_vm._v(" "),_c('el-button',{attrs:{"icon":"","type":"info","size":"mini"},on:{"click":function($event){return _vm.$router.push({name: '客户关系', params: {id: scope.row.id}})}}},[_vm._v("客户关系\n              ")]),_vm._v(" "),_c('router-link',{attrs:{"to":("/customer-project-report/table/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("项目报告")])],1)],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1),_vm._v(" "),_c('customer-receipt-form',{ref:"receiptDialog"})],2),_vm._v(" "),_c('customer-batch-invoice-upload-dialog',{attrs:{"visible":_vm.uploadDialogVisible},on:{"closeDialog":_vm.closeCustomerInvoiceUploadDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("爱绩效客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":true}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"keyword"}},[_c('el-input',{attrs:{"placeholder":"请输入客户名称","clearable":""},model:{value:(_vm.search.keyword),callback:function ($$v) {_vm.$set(_vm.search, "keyword", $$v)},expression:"search.keyword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否显示","prop":"show_filter"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择是否显示","clearable":""},model:{value:(_vm.search.show_filter),callback:function ($$v) {_vm.$set(_vm.search, "show_filter", $$v)},expression:"search.show_filter"}},_vm._l(([{label: '显示', value: '1'}, {label: '不显示', value: '0'}]),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit","size":"mini"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.resetForm('searchForm')}}},[_vm._v("重置\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","min-width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"number","label":"客户编号","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"客户名称","min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.jumpToCustomerProjectTale(scope.row)}}},[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"show_in_statistics","label":"是否显示","min-width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.showInStatistics),function(item){return (scope.row.show_in_statistics === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"company","label":"所属公司","min-width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"客户类型","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.optionModel.customerType),function(item){return (scope.row.type === item.value)?_c('span',[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"managementfees","label":"管理费比例","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm._f("toFixed")(scope.row.managementfees * 100,1))+"%")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adminname","label":"客户联系人","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":"联系方式","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":"邮箱","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"detail","label":"描述","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createtime","label":"创建时间","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.formatDate(scope.row.createtime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatetime","label":"最后更新时间","min-width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.formatDate(scope.row.updatetime)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"icon":"","type":"primary","size":"mini"},on:{"click":function($event){return _vm.openDialog(scope.row)}}},[_vm._v("开票信息\n          ")])]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1),_vm._v(" "),_c('customer-receipt-form',{ref:"receiptDialog"})],2),_vm._v(" "),_c('customer-batch-invoice-upload-dialog',{attrs:{"visible":_vm.uploadDialogVisible},on:{"closeDialog":_vm.closeCustomerInvoiceUploadDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/customer/table"}},[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-table',{staticClass:"margin b15",staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","show-header":false}},[_c('el-table-column',{attrs:{"width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.label))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_vm._v(_vm._s(scope.row.value))])]}}])})],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/customer/table"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":("/customer/balance-flow/" + _vm.id)}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("客户消费记录")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/customer/table"}},[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":'/customer/detail/' + _vm.id}},[_vm._v("客户详情("+_vm._s(_vm.customerName)+")")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"showHeader":false}},[_c('h3',[_vm._v("客户 "+_vm._s(_vm.customerName)+" 当前余额："+_vm._s(_vm.customerBalance))])]),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-export","size":"small"},on:{"click":_vm.onExportSearch}},[_vm._v("流水导出\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"客户ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectid","label":"项目ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"amount","label":"消费金额"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatetime","label":"消费时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskid","label":"相关任务"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"managementfee","label":"管理费用"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.managementfee)+"(管理费率: "+_vm._s(scope.row.managementrate * 100)+"%)")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"desc","label":"备注"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptForm_vue__ = __webpack_require__(1927);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a446ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptForm_vue__ = __webpack_require__(2157);
function injectStyle (ssrContext) {
  __webpack_require__(2155)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a446ce8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerReceiptForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a446ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerReceiptForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/customer-table.d7e496c3ce176a8788d9.js